<template>
  <div class="notfoud-container">
    <div class="img-404"></div>
    <p class="notfound-p">哎呀迷路了...</p>
    <div class="notfound-reason">
      <p>可能的原因：</p>
      <ul>
        <li>原来的页面不存在了</li>
        <li>我们的服务器被外星人劫持了</li>
      </ul>
    </div>
    <div class="notfound-btn-container" @click="toHome()"><span class="notfound-btn">{{count}} 秒后跳转到首页</span></div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      count:''
    }
  },
  mounted() {
   this.countDown()
  },
  methods: {
    countDown(){
      const TIME_COUNT = 10;
      if(!this.timer){
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(()=>{
          if(this.count > 0 && this.count <= TIME_COUNT){
              this.count--;
          }else{
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
              //跳转的页面写在此处
              this.$router.push({
                  path: '/Guide/index?meetingCode='+sessionStorage.getItem('meetingCode')
              });
          }
        },1000)
        }
    },
    toHome() {
      this.$router.push('/Guide/index?meetingCode='+sessionStorage.getItem('meetingCode'));
    }

  },

};
</script>

<style scoped="scoped">
  .notfoud-container .img-404{height:155px;background:url(~@/assets/images/page-404_39c5442.png) center center no-repeat;-webkit-background-size:150px auto;margin-top:40px;margin-bottom:20px}
  .notfoud-container .notfound-p{line-height:22px;font-size:17px;padding-bottom:15px;border-bottom:1px solid #f6f6f6;text-align:center;color:#262b31}
  .notfoud-container .notfound-reason{color:#9ca4ac;font-size:13px;line-height:13px;text-align:left;width:210px;margin:0 auto}
  .notfoud-container .notfound-reason p{margin-top:13px}
  .notfoud-container .notfound-reason ul li{margin-top:10px;margin-left:36px}
  .notfoud-container .notfound-btn-container{margin:40px auto 0;text-align:center}
  .notfoud-container .notfound-btn-container .notfound-btn{display:inline-block;border:1px solid #ebedef;background-color:#009dc6;color:#fff;font-size:15px;border-radius:5px;text-align:center;padding:10px;line-height:16px;white-space:nowrap;cursor: pointer;}
  .notfoud-container .notfound-btn-container .notfound-btn:hover{background: #33d3fc;}
</style>



// WEBPACK FOOTER //
// src/components/404/NotFoundComponent.vue